export enum ComplianceValidationStatusTypeEnum {
    Pending = 1,
    Validated = 2,
    Declined = 3
}
